import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/proxy/checkFlightPricesAndAvailability', request)
}

export {post}
